/** Firestore rejects `undefined`; omit those fields recursively. */
export function stripUndefinedForFirestore(value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null || typeof value !== "object") {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(stripUndefinedForFirestore);
  }
  const cleaned = {};
  for (const [key, nested] of Object.entries(value)) {
    if (nested === undefined) continue;
    cleaned[key] = stripUndefinedForFirestore(nested);
  }
  return cleaned;
}
